import React  from 'react';
import { List, Segment, Divider, Label, Table, Button, Icon, Header, Form,Input} from 'semantic-ui-react';
import {  Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import './PricingTable.css';
moment.locale('es');


//<Button primary size="small" fluid onClick={()=>cursoPago(curso.id)}>Inscribete</Button>

const PricingTable=({curso, cursoPago, user, onInscribir, strings,onChange, cupon, cuponValido })=>{
  	return (

        <div >
            <div class="pricingTable2 blue">
                <div class="pricingTable-header">
                    <h3 class="title">{curso.costo=="-$1.00"?"Pronto":"Oferta"}</h3>
                    <div class="price-value">{curso.costo=="-$1.00"?"más información":curso.costo + "USD"}</div>
                </div>
                
                <Segment basic>
        
                    <Table collapsing compact="very" basic='very' celled collapsing>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Icon name='calendar alternate outline' color="blue"  size='large' />
                                </Table.Cell>
                                <Table.Cell>{moment(curso.fechaInicio).format('LL')}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    <Icon name='file alternate' color="blue"  size='large' />
                                </Table.Cell>
                                <Table.Cell>{curso.horasTotales} horas</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    <Icon name='tasks' color="red"  size='large' />
                                </Table.Cell>
                                <Table.Cell>{curso.cantidadModulos} módulos</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell colSpan="2">
                                  
                                    {cupon==null || cupon.length<12?
                                    
                                        <Form.Field  >
                                        <Input placeholder="cupon"
                                            value={cupon}
                                            onChange={onChange}
                                            name="cupon"
                                        />        
                                        </Form.Field>        
                                    :       
                                    <>
                                        
                                        {cuponValido.valido?
                                        
                                            <Form.Field  >
                                            <Input placeholder="cupon"
                                                icon={<Icon name='check circle' color='green' />}
                                                labelPosition='right'
                                                value={cupon}
                                                onChange={onChange}
                                                name="cupon"
                                            />            
                                            </Form.Field>    
                                            
                                        :
                                        
                                            <Form.Field  >
                                            <Input placeholder="cupon"
                                                icon={<Icon name='remove circle' color='red' />}
                                                labelPosition='right'
                                                value={cupon}
                                                onChange={onChange}
                                                name="cupon"
                                            />            
                                            </Form.Field>    
                                         
                                        
                                        
                                        }
                                            
                                     </>           
                                    }
                                   
                                </Table.Cell>
                            </Table.Row>
                            
                            
                           
                                
                                
                        </Table.Body>
                    </Table>
                                
                    {curso.costo=="-$1.00"?
                        <p>
                        Realiza una pre-inscripción para que te enviemos información<br/>
                        <Button primary size="small" fluid onClick={()=>cursoPago(curso.id)}>Pre-inscripción</Button>
                        </p>
                        :

                            <>

                            {user==null?  


                                <Link to="/miespacio" ><Button color="teal" >{strings?strings["Ingresar"]:""}</Button></Link>


                              :

                                 <>
                                    {Number(curso.costoFloat)<=Number(0)?
                                        <Button basic color="orange" size="small" onClick={()=>onInscribir("1")}>
                                            <Icon.Group size='large' >
                                                <Icon name='user' color="blue" />
                                                <Icon corner name='add' color="blue" />
                                            </Icon.Group>
                                            &nbsp;{strings?strings["Comprar"]:""}
                                        </Button>
                                    :
                                        <Button basic color="blue" size="small" onClick={()=>onInscribir("2")}>
                                            <Icon.Group size='large' >
                                                <Icon name='user' color="blue" />
                                                <Icon corner name='add' color="blue" />
                                            </Icon.Group>
                                            &nbsp;{strings?strings["Comprar"]:""}
                                        </Button>
                                    }
                                    </>




                            }

                            </>
                    }
        
          
        
                </Segment>
            </div>
        </div>
        
        
    );
};



export default PricingTable;